import React from 'react';

import './Discover.css'
import { Link } from 'react-router-dom';
import useLangLink from "../../utils/useLangLink";
import { useTranslation } from 'react-i18next';

import discoverItemIcon1 from '../../assets/images/Home/discoverItemIcon1.svg'
import discoverItemIcon2 from '../../assets/images/Home/discoverItemIcon2.svg'
import discoverItemIcon3 from '../../assets/images/Home/discoverItemIcon3.svg'
import discoverItemIcon4 from '../../assets/images/Home/discoverItemIcon4.svg'
import discoverItemIcon5 from '../../assets/images/Home/discoverItemIcon5.svg'
import discoverItemIcon6 from '../../assets/images/Home/discoverItemIcon6.svg'

const Discover = () => {
    const { t } = useTranslation();
    const lp = useLangLink();
    const ts = (k, d) => t(`sections.discover.${k}`, d);

    const discoverIcons = [discoverItemIcon1, discoverItemIcon2, discoverItemIcon3, discoverItemIcon4, discoverItemIcon5, discoverItemIcon6];
    const discoverLinks = ['/ready-made', '/ready-made-companies-corporate-bank-accounts', '/financial-license', '/financial-license', '/offshore-company-formation', '/offshore-bank-account-opening'];
    const ourServicesArr = (ts('items', { returnObjects: true }) || []).map((it, i) => ({ id: i + 1, ...it, img: discoverIcons[i], link: discoverLinks[i] }))

    return (
        <div className="discover-our-services">
                <h2 className="discover-our-title">
                    {ts('title')}
                </h2>
                <div className="discover-our-sub-title-wrapper">
                    <p className="discover-our-sub-title">
                        {ts('subtitle')}
                    </p>
                </div>
                <div className="discover-keys-wrapper">
                    {ourServicesArr.map((item) => (
                        <Link className="discover-key-item" key={item.id} to={lp(item.link)}>
                            <div className="discover-item-header-wrapper">
                                <h3 className="discover-item-title">
                                    {item.title}
                                </h3>
                                <div className="discover-item-img-wrapper">
                                    <img src={item.img} />
                                </div>
                            </div>
                            <p className="discover-item-descr">
                                {item.descr}
                            </p>
                        </Link>
                    ))}
                    
                </div>
            </div>
    );
};

export default Discover;